import {
  ItemListType,
  LoginMethodType,
  GtmEvents,
} from '../enums/gtm.enum';

export interface GTMDataLayer {
  event: string | GtmEvents | any;
  user_id?: string;
  user_scope?: string;
  customerAccount?: string;
  customerCountry?: string;
  sales_area?: string;
  authentication_method?: LoginMethodType;
  ecommerce?: Ecommerce;
  userType?: any;
  cartType?: string;
  commerceType?: GTMCartType;
  cart_id?: string;
}

export interface Ecommerce {
  item_list_id?: ItemListType;
  item_list_name?: ItemListType;
  transaction_id?: string;
  quote_id?: string;
  value?: any;
  tax?: any;
  shipping?: any;
  currency?: string;
  coupon?: string;
  items?: EcommerceItem[];
}

export enum GTMCartType {
  BUY_CART = 'BUY CART',
  QUOTE_CART = 'QUOTE CART',
  QUOTE_TO_ORDER = 'QUOTE TO ORDER',
}
export interface EcommerceItem {
  item_id: string;
  item_name: string;
  item_type?: string;
  coupon?: string;
  discount?: number | '';
  index: number | '';
  item_category?: string;
  item_category2?: string;
  item_category3?: string;
  item_category4?: string;
  item_category5?: string;
  item_list_id?: ItemListType;
  item_list_name?: ItemListType;
  item_variant?: string;
  price: number | '';
  quantity?: number;
  lead_time?: string;
}
